import {
  formatShipmentArticles,
  shipmentArticleItems,
  shipmentQuantity,
  shipmentSenderBranch,
} from "../../utils/statusUpdateShipmentDisplay.js"

export const ArticleNames = ({ shipment }) => {
  const items = shipmentArticleItems(shipment)
  if (!items.length) return <span className="text-gray-400">—</span>
  if (items.length === 1) {
    return <span className="break-words">{items[0].name}</span>
  }
  return (
    <span className="block leading-snug break-words" title={formatShipmentArticles(shipment)}>
      {items.map((item, index) => (
        <span key={`${item.name}-${index}`} className="block">
          {item.qty != null ? `${item.name} × ${item.qty}` : item.name}
        </span>
      ))}
    </span>
  )
}

export const QuantityValue = ({ shipment }) => {
  const qty = shipmentQuantity(shipment)
  if (qty == null) return <span className="text-gray-400">—</span>
  return <span>{qty}</span>
}

export const SenderBranchValue = ({ shipment }) => {
  const name = shipmentSenderBranch(shipment)
  if (!name) return <span className="text-gray-400">—</span>
  return <span className="break-words">{name}</span>
}
